import { render, staticRenderFns } from "./HomeHelpfulHints.vue?vue&type=template&id=33841e4d&scoped=true&"
import script from "./HomeHelpfulHints.vue?vue&type=script&lang=js&"
export * from "./HomeHelpfulHints.vue?vue&type=script&lang=js&"
import style0 from "./HomeHelpfulHints.vue?vue&type=style&index=0&id=33841e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33841e4d",
  null
  
)

export default component.exports